import { render } from "./SharedSurveyView.vue?vue&type=template&id=bdadd870"
import script from "./SharedSurveyView.vue?vue&type=script&lang=ts"
export * from "./SharedSurveyView.vue?vue&type=script&lang=ts"
script.render = render

export default script